import { DocumentTypes } from "../../data-billed-form.interface";

// ARCA data
export interface ResponseArca {
  status: string;
  message: string;
  data: TypeIvaArca[] | CurrenciesArca[] | DocTypesArca[] | ConceptTypesArca[]
};

export interface ClientsAllBilledResponse {
  res: number;
  cod: number;
  men: string;
  data: ClientsAllBIlled[]
}

export interface ClientsAllBIlled {
  id: number;
  address: string;
  city: string;
  country_id: string;
  cuit: string;
  document_number: string;
  document_type: DocumentTypes;
  document_type_id: number;
  email: string;
  first_name: string;
  iva_id: string;
  last_name: string;
  phone: string;
  phone_code: string;
  postal_code: string;
  state_id: number;
}

export interface ArcaData {
  ivaConditions?: any[];
  receiverIVAConditions?: any[];
  currencies?: CurrenciesArca[];
  ivaTypes?: TypeIvaArca[];
  tourismItems?: any;
  enterprises?: any[];
  documentTypes?: DocTypesArca[];
  receiptTypes?: any[];
  conceptTypes?: ConceptTypesArca[];
  invoiceCountries?: any[];
  bookingDocumentTypes?: any[];
  clients?: ClientsAllBilledResponse;
  countries?: any;
  destinations?: { [country: string]: any[] };
  cities?: { [destination: number]: any[] };
}

export interface TypeIvaArca {
  Id: string;
  Desc: string;
  FchDesde: string;
  FchHasta: string;
};

export interface CurrenciesArca {
  Id: string;
  Desc: string;
  FchDesde: string;
  FchHasta: string;
};

export interface DocTypesArca {
  Id: string;
  Desc: string;
  FchDesde: string;
  FchHasta: string;
};

export interface ConceptTypesArca {
  Id: string;
  Desc: string;
  FchDesde: string;
  FchHasta: string;
};


// Data_Arca facturación

export interface  Billing_data {
                 name: string,
                 address: string,
                 email: string,
                 document_number: string,
                 doc_type: number,
                 document_type_name: string,
                 phone: string,
                 iva: string,
                 iva_condition_id: number | string,
                 iva_condition_name: string | number,
                 receipt_type: number,
                 receipt_type_name: string
                 concept_type: number,
                 client_postal_code: string,
                 client_city: string,
                 client_province: string,
                 client_country: string,
                 products: any[],
                 file_id_abaco: number,
                 total_iva: number,
                 total_taxed: number,
                 total_untaxed: number,
                 client_country_code?: null,
                 currency: string,
                 currency_code_payment_booking: string,
                 iva_details?: any,
                 same_currency_foreign?: boolean,
                 passenger: PaxListFileCreate[]
};

export interface PaxListFileCreate {
    full_name: string;
    document_type: string;
    document_number: string;
};


